import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})
// 全局错误处理，拦截无权限报错
window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.isPermissionError) {
    event.preventDefault()
    // console.log('已拦截权限错误提示')
  }
})

app.mount('#app')
